import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import seoData from '../seo/services.json';

export default function Services() {
  const services = [
    {
      icon: '\u2708',
      title: 'Airport Transfers',
      desc: 'Professional airport pickups and drop-offs at LAX, Hollywood Burbank (BUR), Long Beach (LGB), Ontario (ONT), John Wayne (SNA), and all Southern California airports. We track your flight in real-time and adjust for delays.',
      features: ['Real-time flight tracking', 'Meet & greet at arrivals', 'Luggage assistance', 'All SoCal airports'],
    },
    {
      icon: '\uD83C\uDFE2',
      title: 'Corporate & Executive Travel',
      desc: 'Impress clients and executives with premium black car transportation. We handle the logistics so you can focus on business. Reliable, punctual, and discreet service.',
      features: ['Corporate accounts available', 'Multi-stop itineraries', 'Conference transport', 'Confidential & discreet'],
    },
    {
      icon: '\uD83D\uDC8D',
      title: 'Weddings & Special Events',
      desc: 'Your special day deserves the best. Arrive in style with our fleet of black luxury vehicles. We coordinate multiple vehicle arrivals for wedding parties.',
      features: ['Multiple vehicles for groups', 'Coordinated arrivals', 'Red carpet service', 'Photography-friendly timing'],
    },
    {
      icon: '\uD83C\uDF19',
      title: 'Nightlife & Entertainment',
      desc: 'Experience the best of Los Angeles nightlife with a professional chauffeur. Club runs in Hollywood, Beverly Hills restaurant hopping, and safe rides home.',
      features: ['Multi-stop club runs', 'Hollywood & Beverly Hills', 'Concert & venue transport', 'Safe late-night service'],
    },
    {
      icon: '\uD83C\uDF77',
      title: 'Wine Tours & Sightseeing',
      desc: 'Explore Malibu vineyards, Santa Barbara wine country, or the iconic sights of Los Angeles in ultimate comfort. Full-day or half-day tours available.',
      features: ['Malibu & Santa Barbara', 'Custom itineraries', 'Full & half-day options', 'Scenic route knowledge'],
    },
    {
      icon: '\u23F0',
      title: 'Hourly Charter',
      desc: 'Need a luxury vehicle at your disposal? Book by the hour for maximum flexibility. Perfect for multiple errands, meetings, or any day requiring a chauffeur on standby.',
      features: ['Flexible scheduling', 'As-directed service', 'Wait time included', 'No per-mile charges'],
    },
  ];

  return (
    <>
      <SEOHead seo={seoData} />

      <section className="page-header">
        <div className="container">
          <div className="section-label">What We Offer</div>
          <h1>Our <em>Services</em></h1>
          <div className="gold-line" />
          <p>
            From airport transfers to all-day charters, every ride with us
            is a premium experience.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="services-grid">
            {services.map((s, i) => (
              <div className="service-card" key={i}>
                <div className="service-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <ul className="service-features">
                  {s.features.map((f, j) => (
                    <li key={j}>{f}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="coverage-section">
        <div className="container">
          <div className="section-label">Coverage Area</div>
          <h2 className="section-title">Serving All of Greater Los Angeles</h2>
          <p className="section-subtitle" style={{ margin: '0 auto' }}>
            From downtown LA to Malibu, Hollywood to the South Bay, Pasadena to Long Beach —
            we cover the entire greater Los Angeles area and beyond. Orange County, Ventura County,
            and long-distance trips to Las Vegas, San Diego, and Santa Barbara also available.
          </p>
        </div>
      </section>

      <section className="cta-banner">
        <div className="container">
          <h2>Book Your Service</h2>
          <p>Call us directly for the fastest booking experience.</p>
          <div className="cta-actions">
            <a href="tel:8189154566" className="btn-primary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              (818) 915-4566
            </a>
            <a href="tel:8183559929" className="btn-outline">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              (818) 355-9929
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
